import picture from "../../assets/images/views/masks-certificate.jpg";

export default [
  {
    smallView: picture,
    largeView: picture
  }
];
